/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverapppreviewtitle3Inputs */

const en_coverapppreviewtitle3 = /** @type {(inputs: Coverapppreviewtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How people see it in the app`)
};

const de_coverapppreviewtitle3 = /** @type {(inputs: Coverapppreviewtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sehen es die Leute in der App`)
};

/**
* | output |
* | --- |
* | "How people see it in the app" |
*
* @param {Coverapppreviewtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverapppreviewtitle3 = /** @type {((inputs?: Coverapppreviewtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverapppreviewtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverapppreviewtitle3(inputs)
	return de_coverapppreviewtitle3(inputs)
});
export { coverapppreviewtitle3 as "coverAppPreviewTitle" }